var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.194385 16.0878H3.47664V5.29283H0.194385V16.0878ZM1.83489 3.81758C2.98015 3.81758 3.69207 2.98793 3.69207 1.9539C3.67102 0.894162 2.98015 0.0888672 1.85718 0.0888672C0.732966 0.0888672 0 0.894162 0 1.9539C0 2.98793 0.711918 3.81758 1.81261 3.81758H1.83489Z",
    fill: "#151515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92236 16.0899H8.55012V10.0457C8.55012 9.72418 8.57475 9.39857 8.67054 9.16793C8.93328 8.52213 9.52992 7.85327 10.533 7.85327C11.8453 7.85327 12.3695 8.84639 12.3695 10.2994V16.0899H15.9986V9.88563C15.9986 6.56168 14.2086 5.01367 11.8193 5.01367C9.86246 5.01367 9.00444 6.09904 8.52822 6.83845H8.55012V5.26738H4.92236C4.97163 6.2822 4.92236 16.0899 4.92236 16.0899Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.ac45f9d16d8115916673a5c7cf995ea2.svg";
export { ForwardRef as ReactComponent };